import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { OrderLifetimeAction } from '../orderLifetime.action';
import { OrderLifetimeTranslator } from '../orderLifetime.translator';

type IDependencies = IClientApiDependencySegment;

export const createOrderLifetimeEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeAction.create.started),
  switchMap((params) => {
    const { reject } = params;
    const apiPayload = OrderLifetimeTranslator.toApi(params);

    return dependencies.api.createOrderLifetimeProfile(apiPayload).pipe(
      mergeMap((result) => {
        return [
          OrderLifetimeAction.create.done({
            params,
            result: { orderLifetimeId: result.id },
          }),
          DetailsSidebarAction.close(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          OrderLifetimeAction.create.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
